import {Component} from '@angular/core';
import {formatCurrency} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {ClaimsFinancialFactComponent} from './claims-financial-fact.component';

export interface Claim {
  claimId: string;
  premiumPeriod: string;
  directDebitType: string;
  reminderPhaseDescription: string;
  lastReminderDate: string;
  desiredClaimDate: string;
  originalAmount: number;
  outstandingAmount: number;
  financialFacts: FinancialFact[];
}

export interface FinancialFact {
  claimId: string;
  mutationAmount: number;
  mutationReason: string;
  processingDate: string;
  claimAmount: number;
  outstandingClaimAmount: number;
}

@Component({
  selector: 'app-detail-table',
  templateUrl: './claims-table.component.html',
  styleUrls: ['../../detail-screen/detail-screen.component.css'],
})

export class ClaimsTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: Claim[];
  totalOutstandingAmount;
  totalOriginalAmount;
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor(public dialog: MatDialog) {
    this.tableColumns = [];
    this.tableData = [];
  }

  getAmount(value, currency: string) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatCurrency(value, 'nl', '€', currency);
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }

  openPopUp(claim: Claim) {
    this.dialog.open(ClaimsFinancialFactComponent, {
      width: '800px',
      data: claim.financialFacts,
      panelClass: 'custom-modalbox',
    });
  }

}
